/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Decline_Reason_LabelInputs */

const en_task_decline_reason_label = /** @type {(inputs: Task_Decline_Reason_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const pt_br2_task_decline_reason_label = /** @type {(inputs: Task_Decline_Reason_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Task_Decline_Reason_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_decline_reason_label = /** @type {((inputs?: Task_Decline_Reason_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Decline_Reason_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_decline_reason_label(inputs)
	return pt_br2_task_decline_reason_label(inputs)
});